import { CalendarPermissions } from '@principle-theorem/principle-core/features';
import {
  IRole,
  type Permission,
} from '@principle-theorem/principle-core/interfaces';
import { initFirestoreModel } from '@principle-theorem/shared';
import { uniq } from 'lodash';

export class Role {
  static init(overrides?: Partial<IRole>): IRole {
    return {
      name: 'New Role',
      permissions: [],
      ...initFirestoreModel(),
      ...overrides,
    };
  }

  static withCalendarEventsManagePermission(
    permissions: Permission[] | undefined
  ): Permission[] {
    return uniq([
      ...(permissions ?? []),
      CalendarPermissions.CalendarEventsManage,
    ]);
  }
}
